"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("obsSocialFacebookButton", function() {
    return {
        restrict    : "E",
        scope       : true,
        replace     : true,
        template    : require("./obsSocialFacebookButton.html"),
        link : function($scope, $el, $attrs) {

            $('<div id="fb-root"></div>').appendTo(document.body);

            (function(d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {
                    return;
                }
                js = d.createElement(s);
                js.id = id;
                js.src = "//connect.facebook.net/fr_FR/sdk.js#xfbml=1&version=v2.4&appId=1621263301487516";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));

            $('<div class="fb-share-button" data-layout="button"></div>').appendTo($el);

        }
    };
});


// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/social/obsSocialFacebookButton.js